exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-btn[data-v-203e1a02]{color:#fff}.filter-label[data-v-203e1a02]{font-size:18px;color:#333}.v-autocomplete__content[data-v-203e1a02]{width:160px}", ""]);

// exports
